// src/components/NavBar.js
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { useAuth } from '../AuthProvider';

function NavBar() {
    const ADMINS = [
        'kyle-hinton@outlook.com',
        'lukelittlechief@example.com'
    ];

    const { user } = useAuth();
    const isLoggedIn = !!user && !user.isAnonymous;
    const isAdmin = isLoggedIn && ADMINS.includes(user.email || '');

    const handleLogout = async () => {
        try {
            await signOut(auth);
            console.log("User signed out successfully");
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    return (
        <nav>
            <div className="navbar">
                <div className="navbar-brand">
                    <Link to="/" aria-label="Suitcase Theatre Arcade home">
                        <span>Suitcase Theatre</span>
                        <strong>Arcade</strong>
                    </Link>
                </div>
                <div className="nav-link">
                    <NavLink to="/" end>Home</NavLink>
                </div>
                <div className="nav-link">
                    <NavLink to="/about">About</NavLink>
                </div>
                <div className="nav-link">
                    <NavLink to="/services">Services</NavLink>
                </div>
                <div className="nav-link">
                    <NavLink to="/donate">Donate</NavLink>
                </div>

                <div className="nav-link">
                    <NavLink
                        to="/store"
                    >
                        Store
                    </NavLink>
                </div>
                <div className="nav-link">
                    <NavLink to="/EventList">Events</NavLink>
                </div>
                <div className="nav-link">
                    <NavLink to="/gallery">Gallery</NavLink>
                </div>
                {isAdmin && (
                    <>
                        <div className="nav-link">
                            <NavLink to="/SuitcaseTheatreArcadeDashboard">Manage Content</NavLink>
                        </div>
                        <div className="nav-link">
                            <button onClick={handleLogout}>Logout</button>
                        </div>
                    </>
                )}
            </div>
        </nav>
    );
}

export default NavBar;
